import React, { useMemo } from "react";
import Tooltip from "@mui/material/Tooltip";
import { ICON_LIST, FABRIC_TYPES } from "../constants/iconData";

const FabricItem = ({ icon, title, items }) => {
	return (
		<div className="flex flex-col">
			<div className="flex items-center gap-2 mb-2">
				<Tooltip title={`${title} Compatible`}>
					<img
						src={icon}
						alt={title}
						width={30}
						height={30}
						className="ml-10"
					/>
				</Tooltip>
				<h4 className="font-semibold">{title}:</h4>
			</div>
			<ul className="flex flex-wrap gap-2 pl-9 list-none">
				{items.map((item, index) => (
					<li
						key={index}
						className="text-sm after:content-[','] last:after:content-['']"
					>
						{item}
					</li>
				))}
			</ul>
		</div>
	);
};

const MaterialBankBanner = () => {
	const iconsList = useMemo(() => ICON_LIST, []);
	const fabricTypes = useMemo(() => FABRIC_TYPES, []);

	return (
		<div className="bg-[url('/build/banner.webp')] bg-cover bg-center p-20 w-full max-md:p-4">
			<div className="flex flex-col items-center">
				<div className="flex flex-row gap-6 w-full max-w-7xl max-lg:flex-col">
					{/* Icon Index Box */}
					<div className="bg-white/90 rounded-lg p-6 mb-6 w-1/2 max-md:w-[90%] max-md:mx-auto max-lg:w-full">
						<h3 className="text-2xl font-bold mb-4 text-center">Icon Index</h3>
						<div className="grid grid-cols-2 gap-8 max-lg:gap-2">
							{iconsList.map((icon, index) => (
								<div key={index} className="flex items-center gap-2 text-sm">
									<Tooltip title={icon.title}>
										<img
											src={icon.src}
											alt={icon.title}
											width={30}
											height={30}
										/>
									</Tooltip>
									<span>{icon.title}</span>
								</div>
							))}
						</div>
					</div>

					{/* Fabric Compatibility Box */}
					<div className="bg-white/90 rounded-lg p-6 mb-6 w-1/2 max-md:w-[90%] max-md:mx-auto max-lg:w-full max-lg:p-4">
						<h3 className="text-2xl font-bold mb-4 text-center ">
							Fabric Compatibility
						</h3>
						<div className="flex flex-col gap-4">
							{fabricTypes.map((fabric, index) => (
								<FabricItem
									key={index}
									icon={fabric.icon}
									title={fabric.title}
									items={fabric.items}
								/>
							))}
						</div>
					</div>
				</div>

				<a
					href="/wp-content/uploads/2024/10/Fabric-Specification.pdf"
					target="_blank"
					rel="noopener noreferrer"
					className="bg-[#F47920] border-[#F47920] rounded-3xl px-20 py-4 flex flex-col items-center my-6 text-white hover:text-[#1A3463] hover:bg-[#FDFBFB] hover:border-[#1A3463] border-[1px] max-lg:px-10"
				>
					Fabric Specification Chart
				</a>
				<div className="mx-2 text-xl max-lg:text-sm max-lg:text-center">
					If you have any questions, please{" "}
					<a className="font-bold hover:text-[#F47920]" href="/contact-us">
						<b>contact us</b>
					</a>
					.
				</div>
			</div>
		</div>
	);
};

export default MaterialBankBanner;
